const diagnosisRouter = {
  path: 'diagnosis',
  name: '',
  component: () => import('@/views/service-tools/diagnosis/index.vue'),
  redirect: '/service-tools/diagnosis',
  meta: { title: 'diagnosis', icon: '' },
  children: [
    {
      path: '',
      name: 'Diagnosis',
      component: () => import('@/views/service-tools/diagnosis/Diagnosis.vue'),
      meta: { id: 'allDiagnosis', title: '', icon: '', style: 'black' }
    },
    {
      path: 'hmi',
      name: 'HMI',
      component: () => import('@/views/service-tools/diagnosis/Hmi.vue'),
      meta: { id: 'hmi', title: 'HMI', icon: '', style: 'black' }
    },
    {
      path: 'sensor',
      name: 'Sensor',
      component: () => import('@/views/service-tools/diagnosis/Sensor.vue'),
      meta: { id: 'sensor', title: 'Sensor', icon: '', style: 'black' }
    },
    {
      path: 'driver',
      name: 'Driver',
      component: () => import('@/views/service-tools/diagnosis/Driver.vue'),
      meta: { id: 'driver', title: 'Driver', icon: '', style: 'black' }
    },
    {
      path: 'motor',
      name: 'Motor',
      component: () => import('@/views/service-tools/diagnosis/Motor.vue'),
      meta: { id: 'motor', title: 'Motor', icon: '', style: 'black' }
    },
    {
      path: 'battery',
      name: 'Battery',
      component: () => import('@/views/service-tools/diagnosis/Battery.vue'),
      meta: { id: 'battery', title: 'Battery', icon: '', style: 'black' }
    },
    {
      path: 'confirm',
      component: () => import('@/views/service-tools/diagnosis/PdfConfirm.vue'),
      meta: { id: 'pdfConfirm', title: 'Confirm your Item', icon: '', name: '' }
    }
  ]
};

export default diagnosisRouter;
